<!-- task header -->
@if (taskModalService.task$ | async; as task) {
  <div class="sections">
    <section class="section left">
      <img
        alt="Machine Image"
        [class.emptyImg]="!assetPictureId"
        [src]="assetPictureId | rotecImageV2 | async"
      />
    </section>
    <section class="section right">
      <!-- section header -->
      <div class="header">
        <div class="title _flex-row-centered">
          <h3>{{ task.title }}</h3>
          <ma-priority [priority]="task.priority" dark="true"></ma-priority>
          <rotec-icon-v2
            svgIcon="attachment"
            (click)="taskModalService.openDocumentsModal()"
          ></rotec-icon-v2>
        </div>
        <div class="content">
          @for (taskInfoRow of taskInfos; track taskInfoRow) {
            @for (taskInfo of taskInfoRow; track taskInfo) {
              <div class="row">
                <p class="row-name">{{ taskInfo.name | translate }}</p>
                <div class="row-value">
                  {{ taskInfo.value || '-' }}
                </div>
              </div>
            }
          }
          @if (!!!task.executionDate) {
            <div class="row">
              <ma-date class="row-name" [date]="task.dueDate" [dark]="true"></ma-date>
              <ma-status
                class="row-value"
                [dark]="true"
                [status]="task.status"
                [dueDate]="task.dueDate"
                [referenceDate]="task.referenceDate"
              ></ma-status>
            </div>
          }
          <div class="row">
            <p class="row-name" translate>Responsible Company</p>
            <div class="row-value">
              {{ (task.responsibleCompany | translate) || '-' }}
            </div>
          </div>
          <div class="row">
            <p class="row-name" translate>Executive</p>
            <div class="row-value">
              {{ task.executive || '-' }}
            </div>
          </div>
        </div>
      </div>
      <!-- main content -->
      <div class="main">
        <div class="content">
          <ng-content></ng-content>
        </div>
      </div>
    </section>
  </div>
} @else {
  <div class="spinner">
    <div class="spinner-snake"></div>
  </div>
}
